import React from 'react';
import { Text, Callout } from '@scale/scaleui-radix';
import { faBookOpen } from '@fortawesome/pro-solid-svg-icons';
import { CompassInstructions } from '@scale/compass-ui/components/CardInstructions';

const VellumInstructions: React.FC = () => {
  return (
    <CompassInstructions
      header="How to use the Vellum card"
      storageKey="vellumCardInstructionsExpanded"
      icon={faBookOpen}
    >
      <Callout.Text>
        <Text as="p" className="text-sm">
          This card allows you to place orders through the Vellum service for employees. Select a
          drink and customize options, and employee information will be taken from the specified
          columns in the prior card data.
          <Text as="p" className="text-sm mt-3">
            *Note that you can only order a maximum of 3 drinks at a time.
          </Text>
        </Text>
      </Callout.Text>
    </CompassInstructions>
  );
};

export default VellumInstructions;
